import Actions                  from 'Redux/Actions';
import { UserTicketRepository } from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap }             from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';

export const findUserTicketsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findUserTicketsRequest.type),
    mergeMap(action => from(
      UserTicketRepository.findAll(action.payload)
        .then(({ tickets, meta }) => {
          return Actions.findUserTicketsSuccess({ userTickets: tickets, maxCount: meta?.count });
        })
        .catch((error: Error) => Actions.findUserTicketsFailure({ error })),
    )),
  );
};
